"use client"

import { getStringValue } from "@/lib/string-helper"
import { CompanyValue } from "@/types/types"

interface CompanyValueItemProps {
  value: CompanyValue
  className?: string
}

export const CompanyValueItem = ({ value, className = "" }: CompanyValueItemProps) => {
  if (!value) return null

  const title = getStringValue(value.title)
  const description = getStringValue(value.description)

  if (!title && !description) return null

  return (
    <div className={`${className}`}>
      <p className="sm:text-base text-sm text-[#333333] sm:leading-[1.75rem] leading-[1.25rem]">
        {title && <strong className="font-bold">{title}:</strong>}
        {title && description && " "}
        {description && <span className="font-normal">{description}</span>}
      </p>
    </div>
  )
}
